/*
 * KÖRVONAL — Christmas gift guide. Markup, gates and the plan behind it:
 * sections/korvonal-gift-guide.liquid, docs/gift-guide-2026-plan.md.
 *
 * 1. Offer state on the visitor's clock: inside the 2+1 window → bf, else the
 *    trio → trio, else none. Runs before the trio tray's script (both defer,
 *    this one first) and removes the tray's element unless the state is trio.
 * 2. After the cutoff (section setting) the gift card band moves to the top.
 * 3. ?kinek=<view> (or #<view>) puts that recipient's band first; apro, csomagok
 *    and ajandekkartya work the same way for the price-led ads.
 * 4. "Kosárba tesz" adds one unit, a second tap takes it out; "Ezt a hármat
 *    kérem" adds the view's three (the ones not already in the cart) and opens
 *    the drawer. Both redraw the theme's cart chrome the vendor's way and
 *    dispatch cart-updated, which the tray listens for. Never `add-to-cart`:
 *    korvonal-oto opens its modal on that.
 * 5. In the bf state a bar with the tray's look counts every listed product
 *    toward the 2+1 (the trio tray only knows the trio).
 * Events only on the published theme (data-track="1").
 */
(function () {
  'use strict';
  var root = document.getElementById('kvgg');
  if (!root || root.dataset.kvInit) return;
  root.dataset.kvInit = '1';

  var D = root.dataset;
  var now = Date.now() / 1000;
  var mbStart = parseInt(D.mbStart, 10) || 0;
  var mbEnd = parseInt(D.mbEnd, 10) || 0;
  var TRIO = parseInt(D.trio, 10) || 0;
  var state = (mbStart && now >= mbStart && now < mbEnd) ? 'bf' : (TRIO ? 'trio' : 'none');
  root.setAttribute('data-state', state);
  if (state !== 'trio') {
    var tray = root.querySelector('#kv-trio-tray');
    if (tray) tray.parentNode.removeChild(tray);
  }

  var cutoff = parseInt(D.cutoff, 10) || 0;
  if (cutoff && now >= cutoff) root.classList.add('is-late');

  // ── measurement ──────────────────────────────────────────────────────────
  var EP = 'https://api.korvonal.com/api/storefront-events/cmpismusd0000b965jxyb4r46';
  var TRACK = D.track === '1';
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); return v; } catch (e) { return null; } }
  function uuid() { return (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'v-' + Date.now() + '-' + Math.random().toString(16).slice(2); }
  var visitorId = ls('otto_visitor_id') || uuid(); ls('otto_visitor_id', visitorId);
  function track(name, data, id) {
    var ev = { id: id || name + ':' + visitorId + ':' + Date.now(), eventName: name, clientId: visitorId, visitorId: visitorId,
      occurredAt: new Date().toISOString(), url: location.href, data: Object.assign({ page: D.page, state: state }, data || {}) };
    if (!TRACK) { try { (window.__kvGg = window.__kvGg || []).push(ev); } catch (e) {} return; }
    try {
      fetch(EP, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ events: [ev] }) }).catch(function () {});
    } catch (e) {}
  }

  // ── recipient from the link ──────────────────────────────────────────────
  var views = root.querySelector('[data-kvgg-views]');
  var kinek = null;
  try { kinek = new URLSearchParams(location.search).get('kinek'); } catch (e) {}
  if (!kinek && location.hash) kinek = location.hash.slice(1);
  var key = kinek ? String(kinek).replace(/[^a-z0-9-]/gi, '') : '';
  var lead = key && views ? views.querySelector('[data-kvgg-view="' + key + '"]') : null;
  if (lead) views.insertBefore(lead, views.firstChild);
  else if (key) {
    // The price-led landings sit outside the views: apro (5 000 Ft-ig), csomagok
    // (20 000 Ft-ig), ajandekkartya. The flow is ordered in CSS, so lift it there.
    var flow = root.querySelector('[data-kvgg-flow]');
    var sec = document.getElementById(key);
    if (flow && sec && sec.parentNode === flow) { lead = sec; sec.classList.add('kvgg-lead'); }
  }
  if (lead) {
    if (!location.hash) {
      window.addEventListener('load', function () { lead.scrollIntoView({ block: 'start' }); });
    }
  }
  track('gift_guide_seen', { kinek: lead ? kinek : null }, 'gift_guide_seen:' + visitorId + ':' + new Date().toISOString().slice(0, 10));
  Array.prototype.forEach.call(root.querySelectorAll('[data-kvgg-jump]'), function (a) {
    a.addEventListener('click', function () { track('gift_guide_jump', { view: a.getAttribute('data-kvgg-jump'), src: a.getAttribute('data-kvgg-src') || 'picker' }); });
  });

  // ── the tray waits while the hero is on screen, as on the home ────────────
  // The hero's first screen is the photo and the heading; the tray (or the 2+1
  // bar, appended later) would sit on the heading. A class, so the tray's own
  // script keeps owning is-in.
  var hero = root.querySelector('.kvgg-hero');
  if (hero && window.IntersectionObserver) {
    root.classList.add('kvgg-hold');
    new IntersectionObserver(function (es) { root.classList.toggle('kvgg-hold', es[0].isIntersecting); }).observe(hero);
  }

  // ── reach: which views and ready threes a visitor actually scrolls to ─────
  // A 24-screen page on a phone: without this a readout cannot tell an
  // unloved view from one nobody reached. One event per visitor, view and day.
  var day = new Date().toISOString().slice(0, 10);
  if ('IntersectionObserver' in window && views) {
    var order = Array.prototype.map.call(views.querySelectorAll('[data-kvgg-view]'), function (v) { return v.getAttribute('data-kvgg-view'); });
    var reach = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, three = el.hasAttribute('data-kvgg-three');
        var v = three ? el.closest('[data-kvgg-view]').getAttribute('data-kvgg-view') : el.getAttribute('data-kvgg-view');
        var name = three ? 'gift_guide_three_seen' : 'gift_guide_view';
        track(name, { view: v, pos: order.indexOf(v) + 1, alt: three && el.hasAttribute('data-kvgg-alt') }, name + ':' + visitorId + ':' + v + ':' + day);
        reach.unobserve(el);
      });
    }, { threshold: 0.35 });
    Array.prototype.forEach.call(views.querySelectorAll('[data-kvgg-view], [data-kvgg-three]'), function (el) { reach.observe(el); });
  }

  // ── the recipient bar: on screen once the hero picker has scrolled away ──
  var bar = root.querySelector('[data-kvgg-bar]');
  var picker = root.querySelector('.kvg-pick');
  var flow = root.querySelector('[data-kvgg-flow]');
  // The theme's static header scrolls away; `.sticky-header` slides in on
  // scroll-up. The theme builds it with its own script after this one runs, so
  // it is looked up when needed, never once at start.
  var header = null, watched = false;
  if (bar && picker && flow) {
    var barLinks = Array.prototype.slice.call(bar.querySelectorAll('a'));
    var titles = Array.prototype.slice.call(root.querySelectorAll('[data-kvgg-title]'));
    var ticking = false;
    var place = function () {
      ticking = false;
      if (!header) header = document.querySelector('.sticky-header');
      if (header && !watched && 'MutationObserver' in window) { watched = true; new MutationObserver(onScroll).observe(header, { attributes: true, attributeFilter: ['class', 'style'] }); }
      var top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      root.style.setProperty('--kvgg-top', top + 'px');
      var on = picker.getBoundingClientRect().bottom < top && flow.getBoundingClientRect().bottom > top + 160;
      bar.classList.toggle('is-in', on);
      // The view titles stick under the bar (CSS); the hairline shows only while one is stuck.
      var line = top + (on ? bar.offsetHeight : 0);
      root.style.setProperty('--kvgg-bar-h', (on ? bar.offsetHeight : 0) + 'px');
      titles.forEach(function (t) { t.classList.toggle('is-stuck', Math.abs(t.getBoundingClientRect().top - line) < 2); });
    };
    // The sticky header slides in on scroll-up with its own animation, after the
    // scroll event; follow it frame by frame for a moment after any scroll or
    // change to the header, so the bar sits under it rather than beneath it.
    var until = 0;
    var follow = function () { place(); if (Date.now() < until) requestAnimationFrame(follow); };
    var onScroll = function () {
      var running = Date.now() < until;
      until = Date.now() + 800;
      if (!running && !ticking) { ticking = true; requestAnimationFrame(follow); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    place();
    // Mark the view in reading position and keep its chip in sight on phones.
    if ('IntersectionObserver' in window) {
      var current = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var id = e.target.id;
          barLinks.forEach(function (a) {
            var hit = a.getAttribute('data-kvgg-jump') === id;
            if (hit) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
            if (hit) {
              var ul = a.parentNode.parentNode, l = a.parentNode.offsetLeft;
              if (l < ul.scrollLeft || l + a.offsetWidth > ul.scrollLeft + ul.clientWidth) ul.scrollTo({ left: l - 16, behavior: 'smooth' });
            }
          });
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      Array.prototype.forEach.call(root.querySelectorAll('[data-kvgg-view], #apro'), function (el) { current.observe(el); });
    }
  }
  var gcBtn = root.querySelector('[data-kvgg-gcbtn]');
  if (gcBtn) gcBtn.addEventListener('click', function () { track('gift_guide_giftcard', { late: root.classList.contains('is-late') }); });

  // ── cart ─────────────────────────────────────────────────────────────────
  var LABEL_ADD = D.add || 'Kosárba tesz';
  var LABEL_IN = D.added || 'Kosárban';
  var inCart = {}; // variant id → quantity
  var lastCart = null;

  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        lastCart = c;
        inCart = {};
        (c.items || []).forEach(function (i) { inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity; });
        paintButtons();
        if (bf) bf.render(c);
        return c;
      });
  }
  function paintButtons() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-kvgg-add]'), function (b) {
      var q = inCart[b.getAttribute('data-variant')] || 0;
      b.setAttribute('aria-pressed', q ? 'true' : 'false');
      var t = b.querySelector('.button__text');
      if (t) t.textContent = q ? LABEL_IN + ' ✓' : LABEL_ADD;
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-kvgg-trio]'), function (b) {
      var ids = (b.getAttribute('data-kvgg-trio') || '').split(',').filter(Boolean);
      var all = ids.length && ids.every(function (id) { return inCart[id]; });
      b.textContent = all ? (D.threeDone || D.three) + ' ✓' : D.three;
      b.classList.toggle('is-done', !!all);
    });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  // The cart carries the path, like _kv_offer on the 2+1 lander.
  function stampPath(path) {
    var attrs = { _kv_gift: path };
    if (!(lastCart && lastCart.attributes && lastCart.attributes._kv_gift_first)) attrs._kv_gift_first = path;
    return post('/cart/update.js', { attributes: attrs }).catch(function () {});
  }
  // The vendor's own redraw (component-cart.js), then the event the tray and
  // the drawer ladder listen for.
  function redraw(open) {
    return fetch('?section_id=helper-cart', { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (text) {
        if (typeof window.renderHelperCart === 'function') window.renderHelperCart(text);
        document.dispatchEvent(new Event('cart-updated'));
        if (open) {
          var drawer = document.getElementById('site-cart-sidebar');
          if (drawer && typeof drawer.show === 'function') drawer.show();
          else window.location.href = '/cart';
        }
      })
      .catch(function () { if (open) window.location.href = '/cart'; });
  }

  root.addEventListener('click', function (e) {
    var add = e.target.closest('[data-kvgg-add]');
    if (add) {
      if (add.classList.contains('is-busy')) return;
      var vid = add.getAttribute('data-variant');
      var view = add.getAttribute('data-view');
      var had = inCart[vid] || 0;
      add.classList.add('is-busy');
      var chain = had
        ? post('/cart/change.js', { id: vid, quantity: 0 }).then(function () { track('gift_guide_remove', { handle: add.getAttribute('data-handle'), view: view }); })
        : post('/cart/add.js', { items: [{ id: parseInt(vid, 10), quantity: 1 }] }).then(function () {
            track('gift_guide_add', { handle: add.getAttribute('data-handle'), view: view });
            return stampPath('add:' + view);
          });
      chain.then(function () { return redraw(false); })
        .then(readCart)
        .catch(function () { window.location.href = '/cart'; })
        .then(function () { add.classList.remove('is-busy'); });
      return;
    }
    var three = e.target.closest('[data-kvgg-trio]');
    if (three) {
      if (three.classList.contains('is-busy')) return;
      if (three.classList.contains('is-done')) {
        var dr = document.getElementById('site-cart-sidebar');
        if (dr && typeof dr.show === 'function') dr.show(); else window.location.href = '/cart';
        return;
      }
      var ids = (three.getAttribute('data-kvgg-trio') || '').split(',').filter(Boolean);
      var items = ids.filter(function (id) { return !inCart[id]; }).map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
      var tv = three.getAttribute('data-view');
      three.classList.add('is-busy');
      track('gift_guide_trio', { view: tv, added: items.length });
      (items.length ? post('/cart/add.js', { items: items }).then(function () { return stampPath('trio:' + tv); }) : Promise.resolve())
        .then(function () { return redraw(true); })
        .then(readCart)
        .catch(function () { window.location.href = '/cart'; })
        .then(function () { setTimeout(function () { three.classList.remove('is-busy'); }, 1200); });
    }
  });
  // Changes made elsewhere (drawer quantity, removal) repaint the buttons.
  document.addEventListener('cart-updated', function (ev) { if (!ev.kvgg) scheduleRead(); }, true);
  document.addEventListener('add-to-cart', function () { scheduleRead(); }, true);
  var readTimer = null;
  function scheduleRead() { clearTimeout(readTimer); readTimer = setTimeout(readCart, 350); }

  // ── the 2+1 bar (bf state only) ───────────────────────────────────────────
  var bf = null;
  if (state === 'bf') bf = bfBar();
  readCart().catch(function () {});

  function bfBar() {
    var THRESHOLD = parseInt(D.threshold, 10) || 0;
    var css = document.createElement('link');
    css.rel = 'stylesheet'; css.href = D.trayCss; document.head.appendChild(css);
    var el = document.createElement('div');
    el.className = 'kv-tt kvgg-bf';
    el.hidden = true;
    var slots = '';
    for (var s = 0; s < 3; s++) slots += '<li class="kv-tt__slot"><span>' + (s + 1) + '</span></li>';
    el.innerHTML = '<div class="kv-tt__card"><div class="kv-tt__bar" aria-hidden="true"><i></i></div><div class="kv-tt__row">' +
      '<ol class="kv-tt__slots" aria-hidden="true">' + slots + '</ol><strong class="kv-tt__main"><span></span></strong>' +
      '<span class="kv-tt__sub"></span><button type="button" class="kv-tt__cart" aria-label="Kosár">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M5 8h14l-1.2 11.1a1 1 0 0 1-1 .9H7.2a1 1 0 0 1-1-.9L5 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>' +
      '<span class="kv-tt__count"></span></button><span class="kv-tt__live" aria-live="polite"></span></div></div>';
    root.appendChild(el);
    var bar = el.querySelector('.kv-tt__bar i'), sl = el.querySelectorAll('.kv-tt__slot'),
        main = el.querySelector('.kv-tt__main span'), sub = el.querySelector('.kv-tt__sub'),
        count = el.querySelector('.kv-tt__count'), live = el.querySelector('.kv-tt__live');
    var shown = false, parked = false;
    el.querySelector('.kv-tt__cart').addEventListener('click', function () {
      track('gift_guide_cart', {});
      var drawer = document.getElementById('site-cart-sidebar');
      if (drawer && typeof drawer.show === 'function') drawer.show(); else window.location.href = '/cart';
    });
    function vis() { var on = shown && !parked; el.classList.toggle('is-in', on); el.inert = !on; }
    var feet = document.querySelectorAll('.shopify-section-group-footer-group');
    if (!feet.length) feet = document.querySelectorAll('footer');
    if (feet.length && window.IntersectionObserver) {
      var io = new IntersectionObserver(function () {
        parked = Array.prototype.some.call(feet, function (f) {
          if (!f.offsetHeight) return false;
          var r = f.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0;
        });
        vis();
      });
      Array.prototype.forEach.call(feet, function (f) { io.observe(f); });
    }
    function money(c) { return String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' Ft'; }
    function counts(i) {
      // the 2+1 covers standalone products: no bundles, gift cards or the tote
      return !i.gift_card && !/csomag|tote-bag|ajandekkartya/.test(i.handle || '');
    }
    return {
      render: function (cart) {
        var units = 0, pics = [];
        (cart.items || []).slice().reverse().forEach(function (i) {
          if (!counts(i)) return;
          units += i.quantity;
          for (var n = 0; n < i.quantity && pics.length < 3; n++) pics.push(i.image ? i.image + (i.image.indexOf('?') < 0 ? '?' : '&') + 'width=96' : '');
        });
        for (var k = 0; k < 3; k++) {
          sl[k].classList.toggle('is-filled', !!pics[k]);
          sl[k].innerHTML = pics[k] ? '<img src="' + pics[k] + '" alt="" width="44" height="44" loading="lazy">' : '<span>' + (k + 1) + '</span>';
        }
        var full = units >= 3;
        bar.style.transform = 'scaleX(' + (Math.min(units, 3) / 3) + ')';
        el.classList.toggle('is-full', full);
        var freeShip = THRESHOLD && cart.total_price >= THRESHOLD * 100;
        if (!units) { main.textContent = D.bfMain; sub.textContent = ''; }
        else if (!full) { main.textContent = (D.bfLeft || '').replace('[N]', 3 - units); sub.textContent = ''; }
        else {
          main.textContent = D.bfFull + (freeShip ? ' · ingyenes szállítás' : '');
          sub.textContent = cart.total_discount ? money(cart.total_discount) + '-tal olcsóbb, mint külön' : '';
        }
        sub.hidden = !sub.textContent;
        el.classList.toggle('no-sub', sub.hidden);
        live.textContent = main.textContent;
        var n = cart.item_count || 0;
        count.textContent = n; count.hidden = !n;
        if (!shown) { shown = true; el.hidden = false; requestAnimationFrame(function () { requestAnimationFrame(vis); }); }
      }
    };
  }
})();
